import React, { useMemo } from 'react'
import { sortBy } from 'lodash'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'

type Props = {
  groupedAwards: Record<string, wowaudit.LootHistoryItem[]>
  maxSize: number
  categoryOrder: number[]
}

const LootStatisticsBar = ({
  groupedAwards,
  maxSize,
  categoryOrder,
}: Props) => {
  const sortedGroups = useMemo(() => {
    return sortBy(Object.keys(groupedAwards), (group) =>
      categoryOrder.indexOf(parseInt(group)),
    )
  }, [groupedAwards])

  return (
    <div className='flex w-full h-4 brightness-90'>
      {sortedGroups.map((group, index) => {
        const percentage = (groupedAwards[group].length / maxSize) * 100
        const responseType = groupedAwards[group][0].propagated_reponse_type
        const isFirst = index === 0
        const isLast = index === sortedGroups.length - 1

        if (responseType.excluded) {
          return null
        } else {
          return (
            <Tooltip delayDuration={200} key={responseType.id}>
              <TooltipTrigger asChild>
                <div
                  className={`h-full border-l border-l-muted border-r border-r-muted ${
                    isFirst ? 'rounded-l-sm border-l-0' : ''
                  } ${isLast ? 'rounded-r-sm border-r-0' : ''}`}
                  style={{
                    background: responseType.rgba,
                    width: `${percentage}%`,
                  }}
                />
              </TooltipTrigger>
              <TooltipContent side='top'>{responseType.name}</TooltipContent>
            </Tooltip>
          )
        }
      })}
    </div>
  )
}

export default LootStatisticsBar
